import { render, staticRenderFns } from "./AudioButton.vue?vue&type=template&id=24ef7e64"
import script from "./AudioButton.vue?vue&type=script&lang=js"
export * from "./AudioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports